/**
 * FirmaStandDetailPage.jsx — Firma Tarafı Stand Detayı
 * Route: /Firma/Anasayfa/:standId
 *
 * StandOverviewDetailPage.jsx'in (admin tarafı) firma-facing karşılığı — aynı
 * standOverviewService.js verisini kullanır ama admin'in Uygun/Red onay
 * butonları yerine firma kullanıcısının kendi belgelerini yükleyebildiği bir
 * "Yükle" aksiyonu sunar (uploadStandFile). Onay/red durumu salt-okunur
 * gösterilir — o karar admin tarafına ait. Aynı sebeple "İnşa İzni ve
 * Taahhütnameler" sekmesindeki taahhütname ana belge seçimi de burada
 * yoktur, sadece durum görüntülenir.
 *
 * Talepler/Teknik Talepler/Talepler Borç Durumu sekmeleri buradan ayrılıp
 * kendi sayfasına taşındı — bkz. FirmaTalepStandDetailPage.jsx
 * (/Firma/Talepler/:standId), FirmaTaleplerListPage'in ("Talepler Listesi")
 * satır aksiyonunun hedefi.
 *
 * 2026-07-18: projectService.js'teki revizyon konuşmalarına standId üzerinden
 * salt-okunur köprü eklendi (bkz. getProjectByStandId) — iki servis dosyası ayrı
 * mock veri setleri kullandığı için standId tek ortak alan. Dekoratör metinle
 * yanıtlamaz (yanıt kutusu yok), sadece "Açık Revizyonlar" kartında ve ilgili
 * belge grubundaki ‼ rozetinde konuşmayı görüntüler; dosyayı tekrar yüklemesi
 * (handleUpload → notifyDecoratorFileUpload) konuşmaya otomatik bir sistem
 * mesajı olarak eklenir — bu onun "yanıtı"dır.
 *
 * 2026-07-18: "Kroki" ayrı bir sekme olmaktan çıkarıldı — "Proje Bilgiler"
 * sekmesinin altına kavramsal (henüz işlevsel olmayan) bir kroki önizlemesi
 * eklendi, bkz. ProjectKrokiPreview (FirmaTalepStandDetailPage.jsx'teki
 * MiniKrokiShape ile aynı görsel dil). "Proje Evrakları" sekmesi "Proje
 * Dosyaları" olarak yeniden adlandırıldı. "Elektrik Planı" etiketi bu sayfada
 * ve DOC_GROUPS'u paylaşan diğer sayfalarda "Teknik Talep Planı" oldu.
 *
 * 2026-07-18: "Proje Bilgiler" sekmesindeki Statik Hesap/Proje Görselleri/
 * Teknik Talep Planı özet satırı kaldırıldı — yükleme durumu artık sadece
 * "Proje Dosyaları" sekmesinde. Proje Görselleri (standFileId 5) orada artık
 * tek bir yükleme düğmesi değil: subStandFileId 1-4 (kroki köşeleri) için
 * KrokiShape üzerine yerleşen 4 durum-renkli "göz" butonu (ProjeGorselleriSection
 * → GorselAciButton, admin tarafındaki StandOverviewDetailPage.jsx'teki
 * ProjeGorselleriCard ile aynı köşe/subId sözleşmesi) + subStandFileId 5
 * (Kuşbakışı) için ayrı, küçük bir kroki üzerinde ortalanmış tek göz rozeti.
 * Her ikisi de tıklanınca ProjeGorselUploadModalBody'yi gösteren küçük bir
 * modal açar. Statik Hesap ve Teknik Talep Planı hâlâ eski FirmaDocGroupRow
 * (tek yükleme düğmesi + dosya listesi) ile gösteriliyor.
 *
 * Aynı revizyonda bu sayfadaki tüm durum renkleri (FileStatusBadge, doc-group
 * genel durum ikonu, CommitmentTile, yeni göz butonları) `var(--bs-renk)`
 * inline stilinden STATUS_HEX/NEUTRAL_GRAY sabit hex haritasına taşındı — bu
 * temanın çalışma zamanında `--bs-*` kök CSS değişkenleri tanımlı değil
 * (FirmaProjelerListPage.jsx/FirmaTalepStandDetailPage.jsx'teki aynı not),
 * o yüzden `var(--bs-...)` sessizce şeffafa çözümleniyordu — rozetler DOM'da
 * vardı ama gözle görünmüyordu.
 *
 * 2026-07-23 revizyonu: Projeler Listesi'ndeki ikon-kare kutucuklar artık
 * 2026-09-04: `?focus=revizyonlar` sorgu parametresi eklendi — Projeler
 * Listesi'ndeki revizyon uyarısı ve dört sayaç buraya böyle geliyor, sayfa
 * "Açık Revizyonlar" kartına scroll'lanıp vurgulanıyor (bkz. REVISIONS_ANCHOR_ID).
 *
 * `?tab=<TABS anahtarı>&kategori=<standFileId|commitment key>` ile buraya
 * yönlendiriyor — açılış sekmesi query param'dan seçilir, ilgili belge grubu/
 * taahhütname kartına scrollIntoView + kısa süreli kenarlık vurgusu uygulanır
 * (bkz. focusKategori, RequiredFileRibbon/CommitmentTile'daki id prop'u).
 *
 * 2026-07-18: Proje Görselleri kroki+göz alanının altına her açı için dosya
 * adı/onay durumu/güncelleme tarihini satır satır listeleyen bir özet eklendi
 * (bkz. ProjeGorselDurumSatiri, ALL_GORSEL_SLOTS) — göz butonları sadece renkle
 * durumu gösteriyordu, dosya adı/tarih ancak bu satırlarda okunabiliyor; satıra
 * tıklamak da aynı yükleme modalını açıyor. Teknik Talep Planı satırına da
 * (standFileId 3, FirmaDocGroupRow'un yeni `footer` prop'u üzerinden) dört
 * Teknik Talep kategorisinin (Elektrik/Su/Hava/İnternet) hasRequest/miktar
 * durumunu gösteren bir özet eklendi (bkz. TeknikTalepDurumuRow,
 * standTalepService.getTeknikTalepler) — bu dört kalemin (standTalepService.js'e
 * göre) onay akışı yoktur, o yüzden burada "onaylı/reddedildi" değil "talep var/
 * yok + miktar" gösteriliyor; asıl yönetim hâlâ FirmaTalepStandDetailPage.jsx'teki
 * "Teknik Talepler" sekmesinde. Statik Hesap satırı değişmedi (footer=null).
 * "Proje Durumu" sekmesi "İnşa İzni ve Taahhütnameler" olarak yeniden adlandırıldı
 * (sadece bu sayfada — admin tarafındaki StandOverviewDetailPage.jsx'teki aynı
 * isimli sekmeye dokunulmadı).
 *
 * 2026-07-23 revizyonu (Elektrik Çıkış Noktası): ProjectKrokiPreview artık "Kroki
 * özelliği yakında eklenecek" yer tutucusu değil — sadece Elektrik için, krokiye
 * tıklanarak çıkış noktası işaretlenebiliyor (bkz. InteractiveKrokiPin,
 * standTalepService.js'teki setTeknikExitPoint). standFileId 3 ("Teknik Talep
 * Planı") bu sayfanın "Proje Dosyaları" sekmesinden yüklenmeden çıkış noktası
 * girilemez — eksikse kullanıcı o sekmeye yönlendirilir. Aynı çıkış noktası verisi
 * FirmaTalepStandDetailPage.jsx'teki "Teknik Talepler" sekmesinden (dört
 * kategorinin hepsi için) de okunur/yazılır — iki sayfa aynı kaydı paylaşır.
 *
 * 2026-07-24: Bu sayfa YALNIZCA "Projeler Listesi" (FirmaProjelerListPage.jsx —
 * proje bilgisi/belgesi/taahhütname akışı) ve Ana Sayfa dashboard'ının müşteri-
 * stand satırlarından ("proje detayı" amacıyla) drill-down hedefi — Standlarım
 * listesi ("Standlarım" — genel stand özeti amaçlı) artık kendi ayrı sayfasına
 * (FirmaStandOverviewPage.jsx, /Firma/Standlar/:standId) yönleniyor. İki sayfa
 * aynı standOverviewService kaydını okur ama farklı amaçlara hizmet eder — bu
 * yüzden içerikleri kasıtlı olarak örtüşmüyor, bkz. FirmaStandOverviewPage.jsx'in
 * kendi dosya başı notu.
 *
 * 2026-08-11 revizyonu (Konum): "Proje Bilgiler" sekmesinin altındaki tek başına
 * Elektrik-only ProjectKrokiPreview, FirmaStandOverviewPage.jsx'teki ("Standlarım"
 * detay sayfası) Konum sekmesiyle aynı görünüme çıkarıldı — "Standı Gör" (StandKrokiView,
 * artık Su/Hava/İnternet'in de kayıtlıysa çıkış noktalarını salt-okunur gösterir) /
 * "Alanı Gör" (AlanKrokiPlaceholder, standın salondaki yerinin önizlemesi) arasında
 * geçiş anahtarı. Alanı Gör bilerek MOCK kalmaya devam ediyor — backend'de salon içi
 * x/y koordinat/taban planı verisi henüz yok (bkz. o dosyadaki aynı isimli yorum).
 */
import React, { useContext, useEffect, useId, useRef, useState } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import {
  Container, Card, CardBody, Row, Col, Badge, Nav, NavItem, NavLink, Spinner, Alert, Button, ButtonGroup,
  Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, FormGroup,
} from "reactstrap";
import {
  ArrowLeft, Eye, Ruler, Maximize2, Layers3, Building2, Package,
  Check, X, Clock, Upload, Image as ImageIcon, Coins, AlertTriangle,
  Printer, ExternalLink, Download, Send, Inbox,
} from "lucide-react";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import DocumentPreviewModal from "../../Components/Common/DocumentPreviewModal";
// #503: kurumun verdiği örnek (3D Köşe 1-4 için "Örneği görüntüle") -- document_template, belge türü başına.
import BelgeSablonuBaglantilari from "../../Components/Common/BelgeSablonuBaglantilari";
import useSablonHaritasi from "../../Components/Common/useSablonHaritasi";
import MainContext from "../../Components/Contexts/MainContext";
import { getStandOverviewDetail, uploadStandFile, uploadKusbakisi } from "../../services/standOverviewService";
// #439 (2026-10-16): "Alanı Gör" shows the real plan (fdsVector embed, view-only) instead of the placeholder.
import StandKonumKarti from "../../Components/Kroki/StandKonumKarti";
// #319 / #320 (2026-10-11): proje dosyası yalnızca proje modülü WRITE olan arayüzde (Dekoratör) yüklenir.
import { usePortal } from "../../Components/Contexts/PortalContext";
import { MODUL, SEVIYE } from "../../services/portalService";
import {
  getStandTypePath, FILE_APPROVAL_STATUS, getProjectByStandId, notifyDecoratorFileUpload,
  getProjectFileUrl, getProjeGorselleriCorners,
  getRevisableFields, proposeRevisionValue, addRevisionMessage,
  REVISION_STATUS, REVISION_TARGET_KIND, isRevisionUnfinished,
} from "../../services/projectService";
import { getTeknikTalepler } from "../../services/standTalepService";
import KuralIhlalListesi from "../../Components/Projects/KuralIhlalListesi";
import RevisionThread from "../../Components/Projects/RevisionThread";
// #506: the Elektrik tile also says who signed (decorator / decorator + electrician); the level comes from the stand list's commitments[].
import ImzaSeviyesiRozeti from "../../Components/Projects/ImzaSeviyesiRozeti";
import { seviyeyiTasi } from "../../Components/Projects/taahhutnameYardimci";
import { planDosyasi, planYazimlari } from "../../Components/Projects/kusbakisiYardimci";
import { useTranslation } from "react-i18next";
import i18n, { currentLocaleTag } from "../../i18n";

// Canlı standId'ler (StandOverviewDetailPage.jsx/FirmaStandOverviewPage.jsx'teki
// aynı desen — mock standId'ler Mongo-tarzı hex string, gerçek olanlar düz sayı).
function isNumericStandId(id) {
  return /^\d+$/.test(String(id ?? ""));
}

// "Proje Türü"/"Kat Bilgisi" için hangi standTypeId'nin ağaç kırıntısını
// göstereceğimize karar verir — StandOverviewDetailPage.jsx'teki (admin tarafı)
// aynı isimli helper'ın dosya-yerel kopyası, bkz. o dosyadaki gerekçe yorumu.
// Sistem Ataması bekleniyorken bridged.standTypeId hâlâ genel kök tiptir, o
// yüzden dekoratörün asıl beyan ettiği tip (declaredStandTypeId) tercih edilir;
// atandıktan sonra ise bridged.standTypeId (declaredStandTypeId eskimiş olabilir).
function resolveTargetStandTypeId(bridged) {
  const pb = bridged?.projeBeyani;
  return pb?.awaitingSystemAssignment
    ? (pb?.declaredStandTypeId ?? bridged?.standTypeId)
    : (bridged?.standTypeId ?? pb?.declaredStandTypeId);
}

// standTypePath'teki her kırıntı (kök→...→yaprak) Proje Bilgileri'nde ayrı bir
// kutucuk — StandOverviewDetailPage.jsx'teki aynı isimli sabitlerin dosya-yerel
// kopyası, bkz. o dosyadaki gerekçe yorumu.
const TYPE_LEVEL_LABELS = { get 1() { return i18n.t("portal:standDetay.projeTuru"); }, get 2() { return i18n.t("portal:standDetay.katBilgisi"); }, get 3() { return i18n.t("portal:standDetay.materyal"); } };
const TYPE_LEVEL_ICONS = { 1: Layers3, 2: Building2, 3: Package };
function typeLevelLabel(level) {
  return TYPE_LEVEL_LABELS[level] ?? `Alt Tip (Seviye ${level})`;
}
function typeLevelIcon(level) {
  return TYPE_LEVEL_ICONS[level] ?? Package;
}

// Taahhütname akışı: yükle → inceleyen kişi "ana belge" seçer (PUT .../choose,
// backend guide'ının "Marks one file as the one used for PDF generation") →
// dekoratör belgeyi yazdırıp imzalayıp aynı alt-tipe TEKRAR yükler → inceleyen
// kişi bu ikinci (imzalı) dosyayı da seçer → tamamlandı. `choosenToGenerate`
// backend'de TÜM standFileId 5 başlığı için tek seferde sıfırlanır (bkz.
// FE-ProjectController-project-guide.md "/choose" side effect 1), bu yüzden bu alt-
// tipe özel kalıcı sinyal her dosyanın KENDİ approvalStatus'udur (sadece choose ile
// 1 olur, sonraki başka bir choose çağrısıyla sıfırlanmaz) — StandOverviewDetailPage.jsx
// (inceleyen kişi tarafı) ile aynı dosya-yerel kopya.
function deriveCommitmentStage(files) {
  if (!files || files.length === 0) return "empty";
  const latest = files[files.length - 1];
  const anyApprovedBeforeLatest = files.slice(0, -1).some((f) => f.approvalStatus === 1);
  if (latest.approvalStatus === 1) return anyApprovedBeforeLatest ? "done" : "generated";
  return anyApprovedBeforeLatest ? "signedUploaded" : "draft";
}

// Mock kayıtlardaki eski {key,status,fileId} şeklini (stage/files yerine) bu
// sayfanın yeni akışıyla eşlemek için — bkz. commitments tab render'ındaki
// geriye-dönük normalize adımı, mock mod bu sayfada hâlâ salt-okunur kalıyor.
const COMMITMENT_KEY_TO_SUBID = { statik: 1, isg: 2, elektrik: 3 };

const COMMITMENT_STAGE_META = {
  empty:          { get label() { return i18n.t("portal:standDetay.belgeYuklenmedi"); },                         color: "secondary" },
  draft:          { get label() { return i18n.t("portal:standDetay.yuklendiIncelemeBekliyor"); },             color: "warning" },
  generated:      { get label() { return i18n.t("portal:standDetay.taahhutnameOlusturulduYazdiripImzalayin"); }, color: "info" },
  signedUploaded: { get label() { return i18n.t("portal:standDetay.imzaliBelgeYuklendiSonOnay"); }, color: "warning" },
  done:           { get label() { return i18n.t("portal:standDetay.tamamlandi"); },                               color: "success" },
};

// Canlı standId köprüsü — getStandOverviewDetail'in canlı dalı proje/belge
// alanlarını bilerek dışarıda bırakıyor (bkz. standOverviewService.js), bu sayfa
// seviyesinde projectService.getProjectByStandId sonucuyla birleştiriliyor. Bu
// sayfa (FirmaStandOverviewPage.jsx'ten farklı olarak) ham `fileApprovals`'ı da
// kullanıyor (Proje Dosyaları/İnşa İzni sekmeleri standFileId bazlı durum
// gösteriyor), dosya-yerel kopya — aynı desen o dosyada da var.
function mergeLiveProjectIntoStand(stand, bridged) {
  const requiredCount = bridged?.requiredCount ?? 0;
  const approvedCount = bridged?.approvedCount ?? 0;
  return {
    ...stand,
    requiredCount,
    approvedCount,
    fileApprovals: bridged?.fileApprovals ?? [],
    uploadedFiles: bridged?.uploadedFiles ?? [],
    standTypeId: bridged?.standTypeId ?? null,
    projectHeightNumber: bridged?.projectHeightNumber ?? null,
    // Bu sayfanın taahhütname kartları (İSG/Statik/Elektrik) — stand_file 5 alt-id
    // 1=Statik/2=İSG/3=Elektrik'ten türetilir (bkz. beyani-revisions-guide.md
    // Constants tablosu). `files` yükleme sırasına göre (eskiden yeniye) tutulur —
    // `stage` bu diziden deriveCommitmentStage ile türetilir (bkz. yukarıdaki not).
    // #506: `stand.commitments` here is still the stand list's own (the spread above); only its signature level is kept.
    commitments: seviyeyiTasi([
      { subId: 1, key: "statik", label: i18n.t("portal:standDetay.statikTaahutname") },
      { subId: 2, key: "isg", label: i18n.t("portal:standDetay.isgTaahutname") },
      { subId: 3, key: "elektrik", label: i18n.t("portal:standDetay.elektrikTaahutname") },
    ].map(({ subId, key, label }) => {
      const files = (bridged?.uploadedFiles || [])
        .filter((f) => f.standFileId === 5 && f.subStandFileId === subId && !f.deleted)
        .sort((a, b) => new Date(a.uploadedAt) - new Date(b.uploadedAt));
      return { subId, key, label, files, stage: deriveCommitmentStage(files) };
    }), stand.commitments),
  };
}

const TABS = [
  { key: "info", get label() { return i18n.t("portal:standDetay.projeBilgiler"); } },
  { key: "files", get label() { return i18n.t("portal:standDetay.projeDosyalari"); } },
  { key: "commitments", get label() { return i18n.t("portal:standDetay.insaIzniVeTaahhutnameler"); } },
];

// "Açık Revizyonlar" kartının çıpası — Projeler Listesi'ndeki revizyon uyarısı ve
// dört sayaç buraya `?focus=revizyonlar` ile geliyor (bkz. FirmaProjelerListPage.jsx
// RevizyonUyarisi/ProjeSayacStack). `kategori` çıpalarından ayrı tutuluyor: o kart
// sekmeye bağlı değil, her sekmede aynı yerde duruyor.
const REVISIONS_ANCHOR_ID = "proje-anchor-revizyonlar";

// 2026-08-11 revizyonu (standFileId düzeltmesi — BUG): mock veri standFileId 2=Statik
// Hesap / 5=Proje Görselleri varsayıyordu, canlı katalog (GET /projects/stand-files-classic)
// FARKLI: 2=3-D Görseller (Proje Görselleri, köşe alt-tipleriyle), 3=Elektrik Planı
// (Teknik Talep Planı), 5=Taahütnameler (bkz. yukarıdaki COMMITMENT_KEY_TO_SUBID — o
// zaten doğruydu, değişmedi), 7=Statik Hesap Bilgisi. Bu ikisi karışınca canlı modda
// "Proje Görselleri" standFileId 5'e (gerçekte Taahütnameler) yazıyordu — köşe
// fotoğrafları ile taahhütname belgeleri AYNI (standFileId, subStandFileId) ad
// alanını paylaşıyor, ör. "3D Köşe 1" (subStandFileId 1) "Statik Taahütname"
// (subStandFileId 1) olarak görünüyordu. Canlı standlarda (fuar 298, stand 57557/1A19)
// doğrulandı — StandOverviewDetailPage.jsx (admin tarafı) bunu zaten doğru çözmüştü,
// bkz. o dosyadaki aynı isimli DOC_GROUPS/getProjeGorselleriCorners yorumu, buraya
// aynı düzeltme taşındı. Mock modda (_mockProjects, _mockStandFiles) eski şema
// korunuyor — o fixture'lar hâlâ 5/2 şemasını kullanıyor.
//
// 2026-08-29: sıra değişti — "Statik Hesap" ikinci satıra, "Teknik Talep Planı"nın
// ÜSTÜNE alındı. Ayrıca bu satır artık koşullu: proje bu belgeyi istemiyorsa hiç
// render edilmiyor (bkz. aşağıdaki statikRequired).
const DOC_GROUPS_MOCK = [
  { standFileId: 5, label: "Proje Görselleri" },
  { standFileId: 2, label: "Statik Hesap" },
  { standFileId: 3, label: "Teknik Talep Planı" },
];
const DOC_GROUPS_LIVE = [
  { standFileId: 2, get label() { return i18n.t("portal:standDetay.projeGorselleri"); } },
  { standFileId: 7, get label() { return i18n.t("portal:standDetay.statikHesap"); } },
  { standFileId: 3, get label() { return i18n.t("portal:standDetay.teknikTalepPlani"); } },
];

// "Statik Hesap"ın belge tipi id'si — mock/canlı katalog farkı için (bkz. yukarıdaki
// 2026-08-11 standFileId düzeltmesi notu). FirmaProjelerListPage.jsx'teki
// BELGE_IDS_MOCK/BELGE_IDS_LIVE.statik ile aynı iki sayı.
const STATIK_STAND_FILE_ID_MOCK = 2;
const STATIK_STAND_FILE_ID_LIVE = 7;

// Renkler sabit hex — bu temanın çalışma zamanı --bs-*/--vz-* CSS değişkenleri
// yok (bkz. aynı çözüm FirmaProjelerListPage.jsx'teki STATUS_HEX/NEUTRAL_GRAY'de).
const NEUTRAL_GRAY = "#878a99";
const STATUS_HEX = { warning: "#f7b84b", success: "#0ab39c", danger: "#f06548" };

function fmtDate(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString(currentLocaleTag(), { day: "2-digit", month: "short", year: "numeric" });
}

function fileKind(name) {
  return /\.(jpe?g|png|gif)$/i.test(name || "") ? "image" : "pdf";
}

// Görsel (file) revizyonların standFileId'sini bu sayfadaki DOC_GROUPS etiketine çevirir
// — kapsanmayan tipler (Malzeme Listesi/Yangın Önlemleri) için jenerik bir yedek isim
// döner. DOC_GROUPS mock/canlı arasında farklı id'ler kullandığından (bkz. dosya başı
// 2026-08-11 standFileId düzeltmesi notu) bileşen içinde ilgili DOC_GROUPS ile
// kapatılmış (closure) bir fonksiyon olarak tanımlanıyor, modül seviyesinde değil.
function makeRevisionFileLabel(docGroups) {
  return (standFileId) => docGroups.find((g) => g.standFileId === standFileId)?.label ?? `Belge Tipi #${standFileId}`;
}

function RequiredFileRibbon({ id, label, children }) {
  return (
    <Card id={id} className="position-relative overflow-hidden h-100">
      <span
        className="badge bg-danger position-absolute text-white"
        style={{
          top: 12, left: -6, padding: "4px 16px 4px 10px",
          clipPath: "polygon(0 0, 100% 0, 88% 50%, 100% 100%, 0 100%)",
          fontSize: "0.7rem", zIndex: 2,
        }}
      >
        {label}
      </span>
      <CardBody className="pt-4">{children}</CardBody>
    </Card>
  );
}

// Kroki gösterimi — grid arka plan + L şeklinde stand poligonu. Hem "Proje
// Bilgiler" sekmesindeki kavramsal önizlemede (ProjectKrokiPreview) hem de
// "Proje Dosyaları" sekmesindeki Proje Görselleri yükleme alanında (kroki
// üzerine yerleşen 4 köşe "göz" butonu + kuşbakışı rozeti) aynı görsel dil
// kullanılıyor.
// 2026-08-13 revizyonu: opsiyonel `point` prop'u — "Konum" sekmesindeki "Standı
// Gör" görünümü artık Teknik Talepler sayfasında işaretlenen Elektrik çıkış
// noktasını salt-okunur olarak burada da gösteriyor (bkz. dosya başı 2026-08-12
// notu — pin oradan kaldırılmıştı, patron talebiyle salt-okunur geri döndü).
// Tıklama/sürükleme YOK, sadece işaretlenmişse noktayı çizer.
function KrokiShape({ size = 160, point = null }) {
  const gridId = useId();
  return (
    <svg viewBox="0 0 120 120" width={size} height={size}>
      <defs>
        <pattern id={gridId} width="15" height="15" patternUnits="userSpaceOnUse">
          <path d="M 15 0 L 0 0 0 15" fill="none" stroke="#d7dfe3" strokeWidth="1" />
        </pattern>
      </defs>
      <rect width="120" height="120" fill={`url(#${gridId})`} />
      <polygon
        points="10,10 65,10 65,65 110,65 110,110 10,110"
        fill="#178f8f" fillOpacity="0.18" stroke="#178f8f" strokeWidth="1.5"
      />
      {point && (
        <circle cx={point.x * 120} cy={point.y * 120} r="5" fill="#dc3545" stroke="#fff" strokeWidth="1.5" />
      )}
    </svg>
  );
}

// "Konum" bölümü — "Standı Gör" / "Alanı Gör" arasında geçiş anahtarı, "Proje
// Bilgiler" sekmesinin altında. 2026-08-12 revizyonu: "Standı Gör" artık sadece
// krokinin kendisini gösterir — Elektrik Çıkış Noktası pin'i ve "Kaydet" akışı
// (eskiden StandKrokiView/InteractiveKrokiPin, standTalepService.getTeknikTalepler/
// setTeknikExitPoint) buradan kaldırıldı; o veri hâlâ FirmaTalepStandDetailPage.jsx'teki
// "Teknik Talepler" sekmesinden yönetiliyor, sadece burada TEKRAR gösterilmiyor.
// Ribbon başlığı da artık aktif alt-görünüme göre değişmiyor, sabit "Konum".

/* WAS (until #439): the placeholder of "Alanı Gör"; the view now renders Components/Kroki/StandKonumKarti.jsx (kept as a comment).
// "Alanı Gör" — henüz gerçek bir salon kroki/konum sistemi yok (backend'de
// standların salon içi x/y koordinatları veya salon taban planı verisi
// bulunmuyor) — bilerek MOCK kalıyor (bkz. FirmaStandOverviewPage.jsx'teki
// aynı isimli dosya-yerel kopya). Bu görünüm işlevsel değil — sadece o sistem
// tamamlandığında neyin görüneceğinin önizlemesi: standın salondaki YERİ
// (diğer standların adı gösterilmeden, sadece konumları). Konumlar illüstratif/sabit.
function AlanKrokiPlaceholder({ salonName, standCode }) {
  const { t } = useTranslation("portal");
  const otherSpots = [
    { x: 15, y: 20 }, { x: 45, y: 15 }, { x: 78, y: 22 }, { x: 20, y: 55 },
    { x: 62, y: 62 }, { x: 85, y: 75 }, { x: 32, y: 82 }, { x: 70, y: 40 },
  ];
  return (
    <div className="d-flex flex-column align-items-center py-3">
      <Badge color="warning" className="mb-3">{t("standDetay.onizlemeYakinda")}</Badge>
      <svg viewBox="0 0 100 100" width={220} height={220} className="border rounded-3 bg-light">
        {otherSpots.map((p, i) => (
          <rect key={i} x={p.x - 4} y={p.y - 4} width={8} height={8} rx={1.5} fill="#adb5bd" opacity={0.6} />
        ))}
        <rect x={46} y={46} width={10} height={10} rx={2} fill="#178f8f" stroke="#fff" strokeWidth="1" />
      </svg>
      <div className="text-muted small text-center mt-3" style={{ maxWidth: 340 }}>
        {t("standDetay.krokiKonumSistemiTamamlandigindaBurada")}{" "}<strong>{salonName}</strong>{" "}{t("standDetay.salonununTabanPlaniStandinizin")}<strong>{standCode}</strong>{t("standDetay.yeriIsaretlenmisHaldeGorunecekDiger")}
      </div>
    </div>
  );
}
*/

// ─── Proje Görselleri: standFileId 2 (canlı) / 5 (mock), subStandFileId kroki
// köşeleri (bkz. StandOverviewDetailPage.jsx'teki aynı eşleme, admin tarafındaki
// salt-okunur ProjeGorselleriCard ile aynı köşe/subId sözleşmesi). Firma tarafında
// bunlar tek bir "dosya yükle" düğmesi değil, krokinin dört köşesine yerleşen ve
// o köşeye tıklayınca küçük bir modal açan durum renkli "göz" butonları olarak
// sunuluyor — köşeye konan kamera stand'a bakıyormuş gibi hafifçe merkeze
// döndürülmüş. Mock modda subStandFileId sabit 1-4'tür (_mockProjects fixture'ları
// bunu bekliyor). Canlı modda GERÇEK file_type id'leri (81-84, bkz.
// projectService.getProjeGorselleriCorners) — sabit sayı gömmemek için ada göre
// çözülüp ProjeGorselleriSection'a `angles` prop'u olarak geçirilir (bkz. dosya
// başı 2026-08-11 standFileId düzeltmesi notu).
//
// 2026-08-11 revizyonu (Kuşbakışı → Teknik Talep Planı): Kuşbakışı artık bu
// grubun 5. köşesi değil — TeknikTalepPlaniSection'a taşındı ve standFileId 3'e
// (Teknik Talep Planı, gerçek katalogda "Elektrik Planı") doğrudan yükler, hiçbir
// subStandFileId taşımaz. Backend guide'ının notu ("Kuşbakışı ... aynı çizim
// Teknik Talep çıkış-noktası referansı ve Elektrik taahhütname kaynağı olarak da
// kullanılıyor, üç ayrı dosya olarak modellenmesin") burada "kuşbakışı yükleme =
// Teknik Talep Planı" eşleşmesiyle karşılanıyor — sadece o dosyayı yükleme YÖNTEMİ
// (düz "Dosya Yükle" butonu yerine kuşbakışı kroki göz butonu) ve GÖRÜNDÜĞÜ YER
// (Proje Görselleri altı yerine Teknik Talep Planı altı) değişti.
const GORSEL_ACILAR_MOCK = [
  { subStandFileId: 1, label: "3D Köşe 1", corner: "top-left" },
  { subStandFileId: 2, label: "3D Köşe 2", corner: "top-right" },
  { subStandFileId: 3, label: "3D Köşe 3", corner: "bottom-left" },
  { subStandFileId: 4, label: "3D Köşe 4", corner: "bottom-right" },
];
// WAS (until #334): const KUSBAKISI_LABEL = "Kuşbakışı"; -- a top-level constant would freeze one language;
// its uses below read t("standDetay.kusbakisi") at render.
const CORNER_ORDER = ["top-left", "top-right", "bottom-left", "bottom-right"];

const GORSEL_CORNER_STYLE = {
  "top-left": { top: -14, left: -14, transform: "rotate(45deg)" },
  "top-right": { top: -14, right: -14, transform: "rotate(-45deg)" },
  "bottom-left": { bottom: -14, left: -14, transform: "rotate(135deg)" },
  "bottom-right": { bottom: -14, right: -14, transform: "rotate(-135deg)" },
};

function GorselAciButton({ acilar, file, onClick }) {
  const { t } = useTranslation("portal");
  const info = file ? (FILE_APPROVAL_STATUS[file.approvalStatus] ?? FILE_APPROVAL_STATUS[0]) : null;
  return (
    <button
      type="button"
      className="position-absolute d-flex align-items-center justify-content-center rounded-circle border border-2 border-white shadow-sm p-0"
      style={{
        width: 34, height: 34,
        background: info ? (STATUS_HEX[info.color] ?? NEUTRAL_GRAY) : NEUTRAL_GRAY,
        opacity: file ? 1 : 0.6,
        ...GORSEL_CORNER_STYLE[acilar.corner],
      }}
      title={`${acilar.label} — ${info ? info.label : t("standDetay.yuklenmedi")}`}
      onClick={onClick}
    >
      <Eye size={16} color="#fff" />
    </button>
  );
}

function ProjeGorselUploadModalBody({ file, uploading, onUpload, onPreview, sablon }) {
  const { t } = useTranslation("portal");
  const inputRef = useRef(null);
  const info = file ? (FILE_APPROVAL_STATUS[file.approvalStatus] ?? FILE_APPROVAL_STATUS[0]) : null;
  return (
    <div className="d-flex flex-column align-items-center gap-3 py-2">
      {file ? (
        <>
          <FileTile file={file} onPreview={onPreview ? () => onPreview(file) : undefined} />
          <div className="text-center">
            <div className="small text-muted text-truncate" style={{ maxWidth: 240 }}>{file.originalFileName}</div>
            <Badge color={info.color} className="mt-1">{info.label}</Badge>
          </div>
        </>
      ) : (
        <div className="text-muted small">{t("standDetay.henuzDosyaYuklenmedi")}</div>
      )}
      <input
        ref={inputRef}
        type="file"
        className="d-none"
        onChange={(e) => {
          const f = e.target.files?.[0];
          if (f) onUpload(f);
          e.target.value = "";
        }}
      />
      <Button color="primary" outline disabled={uploading} onClick={() => inputRef.current?.click()}>
        <Upload size={16} className="me-1" /> {file ? t("standDetay.yenidenYukle") : t("standDetay.dosyaYukle")}
      </Button>
      <BelgeSablonuBaglantilari sablon={sablon} className="small" />
    </div>
  );
}

// Görsel kroki+göz alanının altında her açının dosya adını, onay durumunu ve
// güncelleme tarihini bir satırda listeler — göz butonlarının rengi durumu
// gösteriyor ama dosya adı/tarih ancak burada okunabiliyor.
function ProjeGorselDurumSatiri({ slot, file, onClick }) {
  const { t } = useTranslation("portal");
  const info = file ? (FILE_APPROVAL_STATUS[file.approvalStatus] ?? FILE_APPROVAL_STATUS[0]) : null;
  return (
    <button
      type="button"
      className="d-flex align-items-center gap-2 w-100 border-0 bg-transparent text-start px-0 py-1 small"
      style={{ cursor: "pointer" }}
      onClick={onClick}
    >
      <span className="text-muted flex-shrink-0" style={{ width: 84 }}>{slot.label}</span>
      <span className="text-truncate flex-grow-1" style={{ minWidth: 0 }}>
        {file ? file.originalFileName : <span className="text-muted fst-italic">{t("standDetay.henuzDosyaYuklenmedi2")}</span>}
      </span>
      {file && (
        <>
          <Badge color={info.color} className="flex-shrink-0">{info.label}</Badge>
          <span className="text-muted flex-shrink-0" style={{ minWidth: 76, textAlign: "right" }}>{fmtDate(file.uploadedAt)}</span>
        </>
      )}
    </button>
  );
}

// `sablonlar` (#503): belge türü -> { bosForm?, ornek? }; canlıda köşenin `subStandFileId`'si gerçek file_type id'si (81-84),
// bu yüzden doğrudan anahtar olur (mock'ta 1-4, şablon yok).
function ProjeGorselleriSection({ id, files, angles, uploading, onUpload, openRevision, onShowRevision, onPreview, sablonlar = {} }) {
  const { t } = useTranslation("portal");
  const [activeSlot, setActiveSlot] = useState(null);
  const bySlot = (subId) => files.find((f) => f.subStandFileId === subId);

  return (
    <RequiredFileRibbon id={id} label={t("standDetay.projeGorselleri")}>
      <div className="w-100 d-flex flex-column align-items-center">
        <div className="d-flex align-items-center justify-content-between w-100 mb-2">
          <div className="text-muted small">{t("standDetay.krokininKosesindekiGozeTiklayarakO")}</div>
          {openRevision && (
            <Badge
              color="danger"
              className="flex-shrink-0"
              style={{ cursor: "pointer" }}
              title={t("standDetay.acikRevizyonIstegiGoruntulemekIcin")}
              onClick={() => onShowRevision(openRevision)}
            >
              <AlertTriangle size={11} className="me-1" />‼
            </Badge>
          )}
        </div>

        <div className="position-relative my-3" style={{ width: 180, height: 180 }}>
          <KrokiShape size={180} />
          {angles.map((a) => (
            <GorselAciButton key={a.subStandFileId ?? a.corner} acilar={a} file={bySlot(a.subStandFileId)} onClick={() => setActiveSlot(a)} />
          ))}
        </div>

        <div className="border-top pt-2 mt-3 w-100">
          {angles.map((slot) => (
            <ProjeGorselDurumSatiri
              key={slot.subStandFileId ?? slot.label}
              slot={slot}
              file={bySlot(slot.subStandFileId)}
              onClick={() => setActiveSlot(slot)}
            />
          ))}
        </div>
      </div>

      <Modal isOpen={!!activeSlot} toggle={() => setActiveSlot(null)}>
        <ModalHeader toggle={() => setActiveSlot(null)}>{activeSlot?.label}</ModalHeader>
        <ModalBody>
          <ProjeGorselUploadModalBody
            file={activeSlot ? bySlot(activeSlot.subStandFileId) : null}
            uploading={uploading}
            onUpload={(file) => onUpload(activeSlot.subStandFileId, file)}
            onPreview={onPreview}
            sablon={activeSlot ? sablonlar[activeSlot.subStandFileId] : null}
          />
        </ModalBody>
      </Modal>
    </RequiredFileRibbon>
  );
}

function FileStatusBadge({ status }) {
  const info = FILE_APPROVAL_STATUS[status] ?? FILE_APPROVAL_STATUS[0];
  const Icon = status === 1 ? Check : status === 2 ? X : Clock;
  return (
    <div
      className="position-absolute d-flex align-items-center justify-content-center rounded-circle border border-2 border-white"
      style={{ width: 18, height: 18, top: -6, right: -6, background: STATUS_HEX[info.color] ?? NEUTRAL_GRAY }}
      title={info.label}
    >
      <Icon size={10} color="#fff" strokeWidth={3} />
    </div>
  );
}

function FileTile({ file, onPreview }) {
  const { t } = useTranslation("portal");
  const kind = fileKind(file.originalFileName);
  return (
    <div
      className="position-relative"
      title={onPreview ? t("standDetay.onizlemekIcinTiklayin", { originalFileName: file.originalFileName }) : file.originalFileName}
      role={onPreview ? "button" : undefined}
      style={onPreview ? { cursor: "pointer" } : undefined}
      onClick={onPreview}
    >
      <div
        className="d-flex align-items-center justify-content-center rounded-3 text-white fw-bold"
        style={{ width: 46, height: 46, background: "#0f6d6d", fontSize: kind === "pdf" ? "0.65rem" : undefined }}
      >
        {kind === "pdf" ? "PDF" : <ImageIcon size={20} />}
      </div>
      <FileStatusBadge status={file.approvalStatus} />
    </div>
  );
}

// 2026-08-11 revizyonu (Kuşbakışı → Teknik Talep Planı, bkz. dosya başı notu):
// eskiden bu grubun altında dört Teknik Talep kategorisinin (Elektrik/Su/Hava/
// İnternet) hasRequest/miktar özetini gösteren bir 4-kutulu satır vardı
// (TeknikTalepDurumuRow) — kaldırıldı, yerine doğrudan Talepler sayfasına
// yönlendiren tek bir düğme kondu (bu sekmede özetlemek yerine asıl yönetim
// yerine göndermek daha az yinelenen/daha bakımı kolay bir yaklaşım). Bu grubun
// dosya yükleme UI'ı da (düz "Dosya Yükle" düğmesi) kaldırıldı — Proje
// Görselleri'nden taşınan Kuşbakışı kroki göz butonu artık standFileId 3'e
// (subStandFileId'siz) doğrudan yüklüyor; "Kuşbakışı" etiketi kalıcı, gerçek bir
// file_type id'sine bağlı değil (o kimlik artık kullanılmıyor, bkz. dosya başı
// notu).
// #696 follow-up (2026-11-03): the "standFileId 3'e yüklüyor" above is no longer the whole story. The backend keeps the Kuşbakışı as 3-D Görseller sub 85 (what
// the Talep Gönder gate and the Elektrik taahhütname read), so an upload of this drawing now files it there AND under 3 (the Elektrik Planı the fair rules still
// require), and `file` is the newest of either. See Components/Projects/kusbakisiYardimci.js.
function TeknikTalepPlaniSection({ id, file, overallStatus, uploading, onUpload, openRevision, onShowRevision, onPreview, onGoToTalepler }) {
  const { t } = useTranslation("portal");
  const [modalOpen, setModalOpen] = useState(false);
  const overallInfo = FILE_APPROVAL_STATUS[overallStatus] ?? FILE_APPROVAL_STATUS[0];
  const OverallIcon = overallStatus === 1 ? Check : overallStatus === 2 ? X : Clock;
  const fileInfo = file ? (FILE_APPROVAL_STATUS[file.approvalStatus] ?? FILE_APPROVAL_STATUS[0]) : null;

  return (
    <RequiredFileRibbon id={id} label={t("standDetay.teknikTalepPlani")}>
      <div className="w-100 d-flex flex-column align-items-center">
        <div className="d-flex align-items-center justify-content-between w-100 mb-2">
          <div className="d-flex align-items-center gap-2">
            <div
              className="d-flex align-items-center justify-content-center rounded-3 flex-shrink-0"
              style={{ width: 40, height: 40, background: STATUS_HEX[overallInfo.color] ?? NEUTRAL_GRAY }}
              title={overallInfo.label}
            >
              <OverallIcon size={20} color="#fff" />
            </div>
            <div className="text-muted small">
              {t("standDetay.kusbakisiFotografinizAyniZamandaTeknik")}
            </div>
          </div>
          {openRevision && (
            <Badge
              color="danger"
              className="flex-shrink-0"
              style={{ cursor: "pointer" }}
              title={t("standDetay.acikRevizyonIstegiGoruntulemekIcin")}
              onClick={() => onShowRevision(openRevision)}
            >
              <AlertTriangle size={11} className="me-1" />‼
            </Badge>
          )}
        </div>

        <button
          type="button"
          className="position-relative border-0 bg-transparent p-0 mt-2"
          style={{ cursor: "pointer" }}
          title={`${t("standDetay.kusbakisi")} — ${fileInfo ? fileInfo.label : t("standDetay.yuklenmedi")}`}
          onClick={() => setModalOpen(true)}
        >
          <KrokiShape size={140} />
          <div
            className="position-absolute top-50 start-50 translate-middle d-flex align-items-center justify-content-center rounded-circle border border-2 border-white shadow-sm"
            style={{ width: 30, height: 30, background: fileInfo ? (STATUS_HEX[fileInfo.color] ?? NEUTRAL_GRAY) : NEUTRAL_GRAY, opacity: file ? 1 : 0.6 }}
          >
            <Eye size={15} color="#fff" />
          </div>
        </button>
        <div className="text-muted small fw-semibold mt-2">{t("standDetay.kusbakisi")}</div>
        {file ? (
          <div className="text-muted small">{file.originalFileName} · {fmtDate(file.uploadedAt)}</div>
        ) : (
          <div className="text-muted small fst-italic">{t("standDetay.henuzDosyaYuklenmedi2")}</div>
        )}

        <Button color="info" outline size="sm" className="mt-3" onClick={onGoToTalepler}>
          <ExternalLink size={14} className="me-1" />{" "}{t("standDetay.teknikTaleplerEGit")}
        </Button>
      </div>

      <Modal isOpen={modalOpen} toggle={() => setModalOpen(false)}>
        <ModalHeader toggle={() => setModalOpen(false)}>{t("standDetay.kusbakisi")}{" "}{t("standDetay.teknikTalepPlani2")}</ModalHeader>
        <ModalBody>
          <ProjeGorselUploadModalBody
            file={file}
            uploading={uploading}
            onUpload={onUpload}
            onPreview={onPreview}
          />
        </ModalBody>
      </Modal>
    </RequiredFileRibbon>
  );
}

function FirmaDocGroupRow({ id, label, standFileId, overallStatus, files, uploading, onUpload, openRevision, onShowRevision, onPreview }) {
  const { t } = useTranslation("portal");
  const inputRef = useRef(null);
  const overallInfo = FILE_APPROVAL_STATUS[overallStatus] ?? FILE_APPROVAL_STATUS[0];
  const OverallIcon = overallStatus === 1 ? Check : overallStatus === 2 ? X : Clock;
  return (
    <RequiredFileRibbon id={id} label={label}>
      <div className="d-flex align-items-center gap-3 flex-wrap">
        <div
          className="d-flex align-items-center justify-content-center rounded-3 flex-shrink-0"
          style={{ width: 40, height: 40, background: STATUS_HEX[overallInfo.color] ?? NEUTRAL_GRAY }}
          title={overallInfo.label}
        >
          <OverallIcon size={20} color="#fff" />
        </div>
        {openRevision && (
          <Badge
            color="danger"
            className="flex-shrink-0"
            style={{ cursor: "pointer" }}
            title={t("standDetay.acikRevizyonIstegiGoruntulemekIcin")}
            onClick={() => onShowRevision(openRevision)}
          >
            <AlertTriangle size={11} className="me-1" />‼
          </Badge>
        )}
        <div className="vr" style={{ height: 40 }} />
        <input
          ref={inputRef}
          type="file"
          className="d-none"
          onChange={(e) => {
            const file = e.target.files?.[0];
            if (file) onUpload(standFileId, file);
            e.target.value = "";
          }}
        />
        <Button
          color="primary" outline size="sm" disabled={uploading}
          className="d-flex align-items-center justify-content-center flex-shrink-0"
          style={{ width: 40, height: 40 }}
          title={t("standDetay.yeniDosyaYukle")}
          onClick={() => inputRef.current?.click()}
        >
          <Upload size={18} />
        </Button>
        {files.length === 0 ? (
          <span className="text-muted small">{t("standDetay.henuzDosyaYuklenmedi")}</span>
        ) : (
          files.map((f) => (
            <FileTile key={f.id} file={f} onPreview={onPreview ? () => onPreview(f) : undefined} />
          ))
        )}
      </div>
    </RequiredFileRibbon>
  );
}

// Aşama simgesi: empty/draft "beklemede saati", generated "yazdır", done "onay".
const COMMITMENT_STAGE_ICON = {
  empty: Clock, draft: Clock, generated: Printer, signedUploaded: Clock, done: Check,
};

function CommitmentTile({ id, label, stage, files, uploading, onUpload, onPreview, isLive, level, elektrikciName }) {
  const { t } = useTranslation("portal");
  const stageMeta = COMMITMENT_STAGE_META[stage] ?? COMMITMENT_STAGE_META.empty;
  const Icon = COMMITMENT_STAGE_ICON[stage] ?? Clock;
  const latest = files && files.length > 0 ? files[files.length - 1] : null;
  const inputRef = useRef(null);
  // Dekoratör sadece "henüz belge yok/taslak" (ilk yükleme) ve "taahhütname
  // oluşturuldu" (imzalı belgeyi tekrar yükleme) aşamalarında yükleme yapabilir —
  // "son onay bekliyor"/"tamamlandı" aşamalarında sıradaki adım inceleyen kişiye ait.
  // onUpload verilmediyse (mock modda çağıran taraf bilerek geçmiyor) salt-okunur kalır.
  const canUpload = !!onUpload && (stage === "empty" || stage === "draft" || stage === "generated");
  const uploadLabel = stage === "generated" ? t("standDetay.imzaliBelgeyiYukle") : (stage === "draft" ? t("standDetay.yenidenYukle") : t("standDetay.belgeYukle"));
  // "generated" aşamasında dosya adı küçük gri bir satırdaydı, indirmenin tek yolu
  // ona tıklayıp önizleme modalını açıp oradaki "Yeni Sekmede Aç" bağlantısını
  // bulmaktı — kullanıcı burada asıl yapılması gereken adımın (indir → yazdır →
  // imzala → yükle) ilk parçasının gözden kaçtığını belirtti. Artık İmzalı Belgeyi
  // Yükle'nin yanına, aynı büyüklükte belirgin bir indirme düğmesi eklendi (sadece
  // canlı modda — mock modda gerçek dosya içeriği/URL'i yok, bkz. DocumentPreviewModal).
  const downloadUrl = isLive && stage === "generated" && latest ? getProjectFileUrl(latest.storedFileName) : null;

  return (
    <Col id={id} md={4} className="text-center mb-3">
      <div
        className="d-inline-flex align-items-center justify-content-center rounded-3 mb-2"
        style={{ width: 50, height: 50, background: STATUS_HEX[stageMeta.color] ?? NEUTRAL_GRAY }}
        title={stageMeta.label}
      >
        <Icon size={22} color="#fff" />
      </div>
      <div className="small fw-semibold">{label}</div>
      <Badge color={stageMeta.color} className="mt-1 fw-normal">{stageMeta.label}</Badge>
      <ImzaSeviyesiRozeti level={level} elektrikciName={elektrikciName} className="mt-1" />

      {latest ? (
        <div
          className="d-flex align-items-center justify-content-center gap-1 mt-2 text-muted small"
          style={{ cursor: onPreview ? "pointer" : undefined }}
          title={latest.originalFileName}
          onClick={onPreview ? () => onPreview(latest) : undefined}
        >
          <ImageIcon size={12} />
          <span className="text-truncate" style={{ maxWidth: 140 }}>{latest.originalFileName}</span>
        </div>
      ) : (
        <div className="text-muted small mt-1 fst-italic">{t("standDetay.belgeYuklenmedi2")}</div>
      )}

      {stage === "generated" && (
        <div className="text-muted small mt-2 px-2">
          {t("standDetay.belgeyiIndiripYazdirinImzalayipTaratin")}
        </div>
      )}
      {stage === "signedUploaded" && (
        <div className="text-muted small mt-2 fst-italic">{t("standDetay.incelemeEkibininSonOnayiBekleniyor")}</div>
      )}

      {canUpload && (
        <>
          <input
            ref={inputRef}
            type="file"
            className="d-none"
            onChange={(e) => {
              const f = e.target.files?.[0];
              if (f) onUpload(f);
              e.target.value = "";
            }}
          />
          <div className="d-flex align-items-center justify-content-center gap-2 mt-2">
            {downloadUrl && (
              <Button
                color="info"
                size="sm"
                tag="a"
                href={downloadUrl}
                target="_blank"
                rel="noreferrer"
                download={latest.originalFileName}
              >
                <Download size={13} className="me-1" />{" "}{t("standDetay.belgeyiIndir")}
              </Button>
            )}
            <Button
              color={stage === "generated" ? "warning" : "primary"}
              outline={stage !== "generated"}
              size="sm"
              disabled={uploading}
              onClick={() => inputRef.current?.click()}
            >
              <Upload size={13} className="me-1" /> {uploadLabel}
            </Button>
          </div>
        </>
      )}
    </Col>
  );
}

export default function FirmaStandDetailPage() {
  const { t: tx } = useTranslation("portal");
  const { standId } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const focusKategori = searchParams.get("kategori");
  // 2026-09-04: `?focus=revizyonlar` — belge kategorisi değil, sayfanın "Açık
  // Revizyonlar" kartı hedefleniyor (revize belgenin yeniden yüklendiği kapı).
  const focusBolum = searchParams.get("focus");
  const isLive = isNumericStandId(standId);
  // #319: Katılımcı arayüzü proje ilerlemesini İZLER, dosya yüklemez (plan: "proje dosyası yükleyemeyecek");
  // kendi dekoratörü olan katılımcı başlıktan Dekoratör arayüzüne geçer. Backend #315 aynı kuralı uygular.
  const portal = usePortal();
  const projeYazabilir = !portal || portal.enAzModul(MODUL.PROJELER, SEVIYE.WRITE);

  const [stand, setStand] = useState(null);
  const [standTypeName, setStandTypeName] = useState(null);
  // "Proje Türü"/"Kat Bilgisi" için tam ağaç kırıntısı (root→kat kategorisi→
  // yaprak) — bkz. resolveTargetStandTypeId ve StandOverviewDetailPage.jsx'teki
  // aynı desenin gerekçe yorumu.
  const [standTypePath, setStandTypePath] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // Projeler Listesi'ndeki bir kutucuktan ?tab=<TABS anahtarı> ile gelinmişse
  // ilgili sekmede açılır (bkz. FirmaProjelerListPage.jsx'teki ProjeStatusTiles/
  // TaahhutnameTiles).
  const [activeTab, setActiveTab] = useState(() => {
    const requested = searchParams.get("tab");
    return TABS.some((t) => t.key === requested) ? requested : "info";
  });
  const [uploading, setUploading] = useState(false);
  const [infoMsg, setInfoMsg] = useState(null);
  // standId köprüsüyle bulunan projectService.js kaydı — çoğu stand için null kalır
  // (bkz. dosya başı 2026-07-18 notu). Salt-okunur: buradan hiçbir mutasyon yapılmaz.
  const [bridgedProject, setBridgedProject] = useState(null);
  const [activeRevision, setActiveRevision] = useState(null);
  // Revizyon yanıtlama — 2026-08-25 (bkz. docs/guides/FE-Revisions-and-KVKK-update-guide.md).
  // Dekoratör tarafı artık salt-okunur DEĞİL: bir beyan alanı (SPEC_FIELD) revizyonuna
  // DEĞER ÖNEREBİLİR (tampon dolar, durum ANSWERED olur, projede hiçbir şey değişmez)
  // ve konuşmaya mesaj yazabilir. Belge (DOCUMENT) revizyonlarının yanıtı hâlâ
  // yüklemedir — orada değer önerme kutusu YOK, backend de 400 döner.
  const [revisionFields, setRevisionFields] = useState([]);
  const [proposalValue, setProposalValue] = useState("");
  const [proposalNote, setProposalNote] = useState("");
  const [revisionReply, setRevisionReply] = useState("");
  const [revisionBusy, setRevisionBusy] = useState(false);
  // Öneri reddedildiğinde gelen kural ihlalleri — metne düzülmeden, veri olarak.
  // Üç severity var (ERROR / WARNING / PERMITTED) ve üçü de ayrı tonda basılmalı.
  const [revisionViolations, setRevisionViolations] = useState([]);
  const [previewFile, setPreviewFile] = useState(null);
  // "Standı Gör" / "Alanı Gör" geçişi — bkz. dosya başı 2026-08-11 notu.
  const [konumView, setKonumView] = useState("stand");
  // Proje Görselleri köşe/kuşbakışı GERÇEK file_type id'leri — sadece canlı modda,
  // bkz. dosya başı 2026-08-11 standFileId düzeltmesi notu + projectService.getProjeGorselleriCorners.
  const [liveCorners, setLiveCorners] = useState(null);
  // #503: fuarın etkin şablonları (örnekler); standın kendi fuarı, yoksa üst çubuktaki. Mock standlarda çekilmez.
  const { selectedFuarId } = useContext(MainContext);
  const sablonlar = useSablonHaritasi(stand?.fuarId ?? selectedFuarId, { etkin: isLive });
  // "Konum" sekmesi, "Standı Gör" — Teknik Talepler sayfasında işaretlenen Elektrik
  // çıkış noktasının salt-okunur önizlemesi (bkz. KrokiShape'in dosya başı 2026-08-13
  // notu). Sadece görüntüleme; değiştirme/kaydetme hâlâ Teknik Talepler sayfasında.
  const [elektrikExitPoint, setElektrikExitPoint] = useState(null);

  useEffect(() => { document.title = i18n.t("portal:standDetay.standDetayiFds"); }, []);

  // Revize edilebilir beyan alanları — etiket ve valueType için (alanın sayı mı
  // evet/hayır mı olduğunu bilmeden doğru input tipini gösteremeyiz).
  useEffect(() => {
    let ignore = false;
    getRevisableFields({ forceLive: isLive })
      .then((list) => { if (!ignore) setRevisionFields(list || []); })
      .catch(() => { if (!ignore) setRevisionFields([]); });
    return () => { ignore = true; };
  }, [isLive]);

  useEffect(() => {
    if (!isLive) return;
    let ignore = false;
    getProjeGorselleriCorners()
      .then((list) => { if (!ignore) setLiveCorners(list || []); })
      .catch(() => { if (!ignore) setLiveCorners([]); });
    return () => { ignore = true; };
  }, [isLive]);

  useEffect(() => {
    let ignore = false;
    // Bilerek forceLive:false — standTalepService.js'teki setTeknikExitPoint KASITLI
    // OLARAK forceLive almıyor, çıkış noktası her zaman _mockTalepler'a yazılır (bkz.
    // o dosyanın dosya başı notu: backend'de bu uç hiç yok). Burada forceLive:isLive
    // geçilirse canlı standlarda gerçek backend'e gidilir ve exitPoint her zaman null
    // döner — Teknik Talepler sayfasında az önce kaydedilen pin hiç görünmez. Aynı
    // mock deposunu okuyarak SPA oturumu boyunca (tam sayfa yenilemeden) iki sayfa
    // arasında tutarlı kalır.
    getTeknikTalepler(standId, { forceLive: false })
      .then((list) => {
        if (ignore) return;
        const elektrik = (list || []).find((r) => r.categoryKey === "elektrik");
        setElektrikExitPoint(elektrik?.exitPoint ?? null);
      })
      .catch(() => { if (!ignore) setElektrikExitPoint(null); });
    return () => { ignore = true; };
  }, [standId]);

  const DOC_GROUPS = isLive ? DOC_GROUPS_LIVE : DOC_GROUPS_MOCK;
  // ⚠️ Etiket çözümü BÖLÜNMEMİŞ DOC_GROUPS üzerinden yapılır: "Statik Hesap"
  // satırı gizlenmiş olsa bile o belgeye açılmış bir revizyonun adı vardır ve
  // "Açık Revizyonlar" kartında doğru görünmelidir.
  const revisionFileLabel = makeRevisionFileLabel(DOC_GROUPS);
  // ─── "Statik Hesap" satırı — yalnızca bu proje için ZORUNLUYSA (2026-08-29) ───
  // Kaynak: projenin DONMUŞ requiredFileIds anlık görüntüsü — canlıda standId
  // köprüsüyle gelen GET /projects/by-stand yanıtından (canlı stand detayı bu alanı
  // bilerek taşımaz, bkz. standOverviewService.getStandOverviewDetail), mock'ta
  // stand kaydının kendi alanından. Bilerek /required-files/effective ÇAĞRILMIYOR:
  // o uç kuralın BUGÜNKÜ hâlini söyler, proje ise reresolve edilene kadar kendi anlık
  // görüntüsüne göre yargılanır (bkz. docs/guides/FE-ProjectController-catalog-guide.md)
  // — ikisi çeliştiğinde dekoratöre gösterilmesi gereken, projenin kendi listesidir.
  // requiredFileIds hiç çözülemediyse (null — köprü kurulamadı) GİZLEMİYORUZ:
  // bilinmeyen bir durumda yükleme alanını kaldırmak, belgesi gerçekten istenen
  // dekoratörü yükleyemez hâle getirir. Boş dizi ise cevap bellidir ("hiçbir belge
  // istenmiyor") ve satır gider.
  const statikStandFileId = isLive ? STATIK_STAND_FILE_ID_LIVE : STATIK_STAND_FILE_ID_MOCK;
  const requiredFileIds = bridgedProject?.requiredFileIds ?? stand?.requiredFileIds ?? null;
  const statikRequired = requiredFileIds == null
    ? true
    : requiredFileIds.map(Number).includes(statikStandFileId);
  const visibleDocGroups = statikRequired
    ? DOC_GROUPS
    : DOC_GROUPS.filter((g) => g.standFileId !== statikStandFileId);
  const projeGorselleriStandFileId = isLive ? 2 : 5;
  // Kuşbakışı artık Proje Görselleri'nin bir köşesi değil (bkz. dosya başı 2026-08-11
  // "Kuşbakışı → Teknik Talep Planı" notu) — sadece 4 gerçek köşe kalıyor, gerçek
  // file_type id'leri liveCorners[0..3]'ten (Kuşbakışı liveCorners[4] artık okunmuyor).
  const projeGorselleriAngles = isLive
    ? CORNER_ORDER.map((corner, i) => {
        const c = (liveCorners || [])[i];
        return { subStandFileId: c?.fileTypeId, label: c?.name ?? tx("standDetay.n3dKose", { v: i + 1 }), corner };
      })
    : GORSEL_ACILAR_MOCK;

  function showInfo(msg) {
    setInfoMsg(msg);
    setTimeout(() => setInfoMsg(null), 3500);
  }

  useEffect(() => {
    let ignore = false;

    async function run() {
      setLoading(true);
      setError(null);
      try {
        const detail = await getStandOverviewDetail(standId, { forceLive: isLive });
        if (ignore) return;

        // Köprü isteğe bağlı bir zenginleştirme — başarısız olursa ana sayfa yine de
        // render edilmeli, bu yüzden ayrı try/catch'te (dış catch'i tetiklemesin).
        let bridged = null;
        if (detail.standId) {
          try {
            bridged = await getProjectByStandId(detail.standId, { forceLive: isLive });
          } catch {
            bridged = null;
          }
        }
        if (ignore) return;
        setBridgedProject(bridged);

        const merged = isLive ? mergeLiveProjectIntoStand(detail, bridged) : detail;
        setStand(merged);

        const targetTypeId = isLive ? resolveTargetStandTypeId(bridged) : merged.standTypeId;
        if (targetTypeId) {
          const path = await getStandTypePath(targetTypeId, { forceLive: isLive });
          if (!ignore) {
            setStandTypeName(path?.[path.length - 1]?.standTypeName ?? null);
            setStandTypePath(path || []);
          }
        }
      } catch (e) {
        if (!ignore) setError(e.message);
      } finally {
        if (!ignore) setLoading(false);
      }
    }

    run();
    return () => { ignore = true; };
  }, [standId, isLive]);

  // Projeler Listesi'ndeki bir belge/taahhütname kutucuğundan ?kategori=<standFileId|key>
  // ile (ya da revizyon uyarısı/sayaçlarından ?focus=revizyonlar ile) gelindiyse
  // ilgili karta scroll edip kısa süreliğine kenarlıkla vurgular.
  // "files"/"commitments" sekmeleri stand yüklendikten sonra senkron render
  // edildiği için (Talepler'in aksine ayrı bir alt-fetch yok) polling gerekmez —
  // React state yerine doğrudan DOM üzerinde çalışır (bkz. aynı gerekçe
  // FirmaPersonelDetailPage.jsx'teki scroll/highlight effect'inde).
  useEffect(() => {
    if (loading || !stand) return;
    const anchorId = focusBolum === "revizyonlar"
      ? REVISIONS_ANCHOR_ID
      : (focusKategori ? `proje-anchor-${activeTab}-${focusKategori}` : null);
    if (!anchorId) return;
    const el = document.getElementById(anchorId);
    if (!el) return;
    el.scrollIntoView({ behavior: "smooth", block: "center" });
    // Vurgu asıl olarak geçici bir GÖLGE HALKASI, kenarlık rengi değil: "Açık
    // Revizyonlar" kartı zaten .border-danger taşıyor ve Bootstrap'te o kural
    // .border-primary'den sonra tanımlı olduğu için sınıfı eklemek rengi hiç
    // değiştirmiyor (canlıda doğrulandı — computed border kırmızı kalıyor).
    // Gölge hangi kenarlık sınıfı olursa olsun görünür.
    el.classList.add("border-primary");
    el.style.borderWidth = "2px";
    el.style.boxShadow = "0 0 0 4px rgba(64, 81, 137, .35)";
    const timer = setTimeout(() => {
      el.classList.remove("border-primary");
      el.style.borderWidth = "";
      el.style.boxShadow = "";
    }, 2500);
    return () => clearTimeout(timer);
  }, [loading, stand, activeTab, focusKategori, focusBolum]);

  async function refreshStand() {
    const detail = await getStandOverviewDetail(standId, { forceLive: isLive });
    let bridged = null;
    if (detail.standId) {
      try {
        bridged = await getProjectByStandId(detail.standId, { forceLive: isLive });
      } catch {
        bridged = null;
      }
    }
    setBridgedProject(bridged);
    setStand(isLive ? mergeLiveProjectIntoStand(detail, bridged) : detail);
    return bridged;
  }

  function closeRevisionModal() {
    setRevisionViolations([]);
    setActiveRevision(null);
    setProposalValue("");
    setProposalNote("");
    setRevisionReply("");
  }

  // Bir mutasyondan sonra proje kaydı yeniden yüklenir ve modal AÇIK KALIR — aksi
  // halde dekoratör önerisini gönderir göndermez konuşma kapanır ve az önce ne
  // gönderdiğini göremez.
  async function afterRevisionMutation() {
    const revisionId = activeRevision?._id;
    const fresh = await refreshStand();
    const updated = fresh?.revisions?.find((r) => r._id === revisionId);
    if (updated) setActiveRevision(updated);
  }

  async function handleProposeValue() {
    if (!bridgedProject?.id || !activeRevision || !String(proposalValue).trim()) return;
    setRevisionBusy(true);
    setRevisionViolations([]);
    setError(null);
    try {
      await proposeRevisionValue(bridgedProject.id, activeRevision._id, proposalValue, {
        note: proposalNote.trim() || null,
        forceLive: isLive,
      });
      setProposalValue("");
      setProposalNote("");
      await afterRevisionMutation();
      setInfoMsg(tx("standDetay.onerinizIletildiIncelemeEkibiOnaylayana"));
    } catch (e) {
      // ⚠️ İhlalleri metne DÜZLEŞTİRMİYORUZ. Birleştirilmiş bir cümle severity'yi
      //    kaybediyor ve 2026-08-28'den beri üç severity var: ERROR (reddedildi),
      //    WARNING (kabul edildi, sadece bilgi) ve PERMITTED (onaylı özel iznin
      //    temizlediği GERÇEK bir ihlal). Üçünü aynı kırmızı satırda basmak, bir uyarıyı
      //    reddedilme gibi gösteriyordu. Liste veri olarak tutulup KuralIhlalListesi
      //    ile basılıyor.
      setError(e.violations?.length ? null : e.message);
      setRevisionViolations(e.violations ?? []);
    } finally {
      setRevisionBusy(false);
    }
  }

  async function handleRevisionReply() {
    if (!bridgedProject?.id || !activeRevision || !revisionReply.trim()) return;
    setRevisionBusy(true);
    setError(null);
    try {
      await addRevisionMessage(
        bridgedProject.id, activeRevision._id, revisionReply.trim(),
        stand?.dekoratorFirmaName || tx("standDetay.dekorator"),
        { authorRole: "company", forceLive: isLive },
      );
      setRevisionReply("");
      await afterRevisionMutation();
    } catch (e) {
      setError(e.message);
    } finally {
      setRevisionBusy(false);
    }
  }

  // `plan: true` = the Kuşbakışı / Teknik Talep Planı drawing, which is filed in two places (kusbakisiYardimci.js): standFileId and
  // subStandFileId are then ignored and a revision open on either place is answered.
  async function handleUpload(standFileId, file, subStandFileId = null, { plan = false } = {}) {
    if (!projeYazabilir) {
      setError(tx("standDetay.buArayuzdeProjeDosyasiYuklenemez"));
      return;
    }
    // 2026-08-11: POST /{id}/files'ı 500'e düşüren "Incorrect DATE value:
    // '0000-00-00'" zero-date hatası backend tarafında düzeltildi (doğrulandı:
    // fuar 298 proje 6a798d33331f0d06c585fa49'a canlı bir dosya başarıyla
    // yüklenip silindi) — bkz. util/knowledgebase/local-backend-testing.md. Artık
    // sadece bağlı bir proje kaydı (bridgedProject) yoksa engelleniyor, o durumda
    // yüklenecek bir proje _id'si zaten yok.
    if (isLive && !bridgedProject?.id) {
      setError(tx("standDetay.buStandinBagliBirInsaat"));
      return;
    }
    setUploading(true);
    setError(null);
    try {
      const yukleme = { forceLive: isLive, projectId: bridgedProject?.id };
      if (plan) await uploadKusbakisi(standId, file, yukleme);
      else await uploadStandFile(standId, standFileId, subStandFileId, file, yukleme);
      // ⚠️ stand.standId (numeric) kullan — standId route param'ı burada mongo _id'dir,
      // notifyDecoratorFileUpload'ın beklediği köprü alanı değil (bkz. dosya başı notu).
      if (stand?.standId) {
        const belgeIdleri = plan ? [...new Set(planYazimlari(isLive).map(([id]) => id))] : [standFileId];
        for (const belgeId of belgeIdleri) {
          await notifyDecoratorFileUpload(stand.standId, belgeId, { originalFileName: file.name }).catch(() => {});
        }
      }
      await refreshStand();
    } catch (e) {
      setError(e.message);
    } finally {
      setUploading(false);
    }
  }

  if (loading) {
    return (
      <div className="page-content">
        <Container fluid className="text-center py-5"><Spinner color="primary" /></Container>
      </div>
    );
  }

  if (error && !stand) {
    return (
      <div className="page-content">
        <Container fluid>
          <Alert color="danger">{error}</Alert>
          <Button color="secondary" outline size="sm" onClick={() => navigate("/Firma/Anasayfa")}>
            <ArrowLeft size={14} className="me-1" />{" "}{tx("standDetay.listeyeDon")}
          </Button>
        </Container>
      </div>
    );
  }

  if (!stand) return null;

  const salonNumber = stand.salonName?.match(/\d+/)?.[0] ?? stand.salonName;
  const izinVar = stand.requiredCount > 0 && stand.approvedCount === stand.requiredCount;
  // Kat kategorisi (Tek Katlı/Çift Katlı) standTypePath'te ayrı bir alan değil,
  // seviye 2'nin adı — bkz. resolveTargetStandTypeId ve FE-ProjectController-
  // catalog-guide.md "GET /stand-type-path".
  const katBilgisiDisplay = standTypePath.find((c) => c.level === 2)?.standTypeName ?? stand.floorInfo ?? null;
  // Proje Bilgileri'nde stand tipinin HER seviyesi ayrı bir kutucuk — kök (Paket/
  // Özel/Pavilyon), kat kategorisi, materyal/alt tip, hepsi birden görünür. Sadece
  // canlı köprüde tam ağaç var (standTypePath); yoksa eski tek-kutucuk davranışına düşer.
  const typeTiles = standTypePath.length > 0
    ? standTypePath.map((crumb) => ({
        icon: typeLevelIcon(crumb.level),
        label: `${typeLevelLabel(crumb.level)}: ${crumb.standTypeName}`,
      }))
    : [{ icon: Layers3, label: tx("standDetay.projeTuru2", { v: standTypeName ?? "—" }) }];

  const fileApprovalsMap = {};
  (stand.fileApprovals || []).forEach((fa) => { fileApprovalsMap[fa.standFileId] = fa.status; });

  // Teknik Talep Planı (standFileId 3, artık Kuşbakışı göz butonuyla yüklenen tek belge,
  // bkz. dosya başı 2026-08-11 notu) — en son yüklenen dosya. uploadedFiles[] backend'de
  // ekleme sırasına göre (eskiden yeniye) tutulur, bkz. FE-ProjectController-project-guide.md
  // "the new file is the last element" — .find() ilk (en eski) eşleşmeyi döner, o yüzden
  // burada en sondaki eşleşme alınır.
  // #696 follow-up: the drawing is filed in two places (Elektrik Planı and 3-D Görseller > Kuşbakışı, see kusbakisiYardimci.js); the newest of either.
  const teknikTalepPlaniFile = planDosyasi(stand.uploadedFiles);

  // Bitmemiş BELGE revizyonu olan belge tipleri → doc-group satırındaki ‼ rozeti.
  // ⚠️ `status === "open"` DEĞİL: dosya yüklenince revizyon ANSWERED'a geçiyor ama
  // hâlâ inceleme ekibinin kararını bekliyor, yani iş bitmiş değil.
  const openVisualByFile = {};
  (bridgedProject?.revisions || []).forEach((r) => {
    if (r.targetKind === "DOCUMENT" && isRevisionUnfinished(r) && r.standFileId != null) {
      const existing = openVisualByFile[r.standFileId];
      if (!existing || new Date(r.updatedAt) > new Date(existing.updatedAt)) openVisualByFile[r.standFileId] = r;
    }
  });
  const openRevisions = (bridgedProject?.revisions || []).filter(isRevisionUnfinished);
  const activeFieldMeta = activeRevision?.fieldKey
    ? revisionFields.find((f) => f.key === activeRevision.fieldKey)
    : null;

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title={tx("standDetay.stand", { standName: stand.standName })} pageTitle={tx("standDetay.firma")} />

        {error && <Alert color="danger">{error}</Alert>}
        {!projeYazabilir && (
          <Alert color="info" className="small">
            {tx("standDetay.buArayuzdeProjeIlerlemesiniIzlersiniz")}
            {portal?.arayuzler?.some((a) => a.rol === "DEKORATOR") && tx("standDetay.kendiDekoratorunuzsenizBasliktanDekoratorArayuzu")}
            {/* #418: the reason this login cannot write the project (its company's set, its role, or a SAKA restriction) */}
            {portal?.ipucu && portal.ipucu(MODUL.PROJELER, SEVIYE.WRITE) && (
              <div className="mt-1 fw-semibold" data-testid="proje-gerekce">{portal.ipucu(MODUL.PROJELER, SEVIYE.WRITE)}</div>
            )}
          </Alert>
        )}
        {infoMsg && <Alert color="info">{infoMsg}</Alert>}

        <Button color="secondary" outline size="sm" className="mb-3" onClick={() => navigate("/Firma/Anasayfa")}>
          <ArrowLeft size={14} className="me-1" />{" "}{tx("standDetay.listeyeDon")}
        </Button>

        <Card className="mb-4 overflow-hidden">
          <div className="bg-light">
            <div className="p-4">
              <div className="d-flex align-items-center gap-3 flex-wrap">
                <div className="bg-white rounded-3 text-center px-3 py-2 shadow-sm" style={{ minWidth: 72 }}>
                  <div className="fw-bold fs-5 text-dark lh-1">{salonNumber}</div>
                  <div className="fw-semibold small text-info lh-1 mt-1">{stand.standName}</div>
                </div>
                <div>
                  <h4 className="text-dark mb-0">{stand.firmaName}</h4>
                  <div className="text-muted small">{stand.dekoratorFirmaName || "—"}</div>
                  <Badge color={izinVar ? "success" : "danger"} className="mt-1">
                    {izinVar ? tx("standDetay.insaatIzniVar") : tx("standDetay.insaatIzniYok")}
                  </Badge>
                </div>
              </div>
            </div>
            <Nav pills className="px-4 gap-2 border-0" style={{ position: "relative" }}>
              {TABS.map((t) => (
                <NavItem key={t.key}>
                  <NavLink
                    active={activeTab === t.key}
                    className={activeTab === t.key ? "bg-danger text-white" : "bg-white text-dark"}
                    style={{ cursor: "pointer", borderRadius: "6px 6px 0 0" }}
                    onClick={() => setActiveTab(t.key)}
                  >
                    {t.label}
                  </NavLink>
                </NavItem>
              ))}
            </Nav>
          </div>
        </Card>

        {/* ─── Açık Revizyonlar — sekmeden bağımsız, her zaman görünür (bkz. dosya
            başı 2026-07-18 notu: dosyaya bağlı olmayan revizyonların tek başlarına
            bir doc-group satırında gösterilecek yerleri yok). "Açık" burada
            KAPANMAMIŞ demek: yanıtladığınız ama henüz karara bağlanmamış olanlar da
            burada durur, yoksa gönderdiğiniz öneri gözden kaybolurdu. ─── */}
        {openRevisions.length > 0 && (
          <Card id={REVISIONS_ANCHOR_ID} className="mb-4 border-danger">
            <CardBody>
              <div className="d-flex align-items-center gap-2 mb-3">
                <AlertTriangle size={18} className="text-danger" />
                <h6 className="mb-0">{tx("standDetay.acikRevizyonlar")}</h6>
              </div>
              <div className="d-flex flex-column gap-2">
                {openRevisions.map((r) => {
                  const fieldLabel = r.fieldKey
                    ? (revisionFields.find((f) => f.key === r.fieldKey)?.label ?? r.fieldKey)
                    : null;
                  // ANSWERED = top karşı tarafta: dekoratör yapacağını yaptı, sıra
                  // inceleme ekibinde. Bu ayrım gösterilmezse dekoratör aynı revizyona
                  // tekrar tekrar yanıt vermeye çalışır.
                  const waitingOnThem = r.status === "answered";
                  return (
                    <div key={r._id} className="border rounded p-2 d-flex justify-content-between align-items-start flex-wrap gap-2">
                      <div>
                        <div className="d-flex align-items-center gap-2 mb-1 flex-wrap">
                          <Badge color={REVISION_TARGET_KIND[r.targetKind]?.color ?? "secondary"}>
                            {REVISION_TARGET_KIND[r.targetKind]?.label ?? r.targetKind}
                          </Badge>
                          <Badge color={REVISION_STATUS[r.status]?.color ?? "secondary"}>
                            {waitingOnThem ? tx("standDetay.incelemede") : (REVISION_STATUS[r.status]?.label ?? r.status)}
                          </Badge>
                          <span className="small text-muted">
                            {r.standFileId != null ? revisionFileLabel(r.standFileId) : (fieldLabel ?? tx("standDetay.projeninGeneli"))}
                          </span>
                        </div>
                        <div className="small">{r.messages[0]?.text}</div>
                      </div>
                      <Button color={waitingOnThem ? "info" : "primary"} outline={waitingOnThem} size="sm" onClick={() => setActiveRevision(r)}>
                        {waitingOnThem ? tx("common:goruntule") : tx("standDetay.yanitla")}
                      </Button>
                    </div>
                  );
                })}
              </div>
            </CardBody>
          </Card>
        )}

        {activeTab === "info" && (
          <>
            <RequiredFileRibbon label={tx("standDetay.projeBilgileri")}>
              <div className="w-100">
                <Row className="text-center">
                  {[
                    ...typeTiles,
                    {
                      icon: Ruler,
                      // standHeightName Sistem Ataması'ndan sonra dolan, projectHeightNumber'dan
                      // (söz verilen/beyan edilen tek sayı) daha spesifik bir alan — onaylanmış
                      // yükseklik BANDI (ör. "4,50 m'den büyük") — bkz. StandOverviewDetailPage.jsx'teki
                      // aynı desen.
                      label: tx("standDetay.stantYuksekligi", { v: stand.projectHeightNumber ? `${stand.projectHeightNumber} m` : "—", v2: bridgedProject?.standHeightName ? ` (${bridgedProject.standHeightName})` : "" }),
                    },
                    { icon: Maximize2, label: tx("standDetay.stantAlani", { v: stand.standArea ? `${stand.standArea} m²` : "—" }) },
                    // typeTiles zaten kat kategorisini (seviye 2) içeriyorsa burada tekrar
                    // etmiyoruz — sadece ağaç çözülemediğinde (mock/fallback) devreye girer.
                    ...(standTypePath.length > 0 ? [] : [{ icon: Building2, label: tx("standDetay.katBilgisi2", { v: katBilgisiDisplay ?? "—" }) }]),
                  ].map(({ icon: Icon, label }) => (
                    <Col md={3} key={label}>
                      <div
                        className="d-inline-flex align-items-center justify-content-center bg-info-subtle text-info rounded-circle mb-2"
                        style={{ width: 44, height: 44 }}
                      >
                        <Icon size={20} />
                      </div>
                      <div className="small">{label}</div>
                    </Col>
                  ))}
                </Row>
              </div>
            </RequiredFileRibbon>

            <div className="text-muted small mt-3">{tx("standDetay.sonGuncelleme")}{" "}{fmtDate(stand.updatedAt)}</div>

            <Row className="g-3 mt-1">
              <Col md={12}>
                <div className="d-flex justify-content-center mb-3">
                  <ButtonGroup>
                    <Button color="info" outline={konumView !== "stand"} onClick={() => setKonumView("stand")}>
                      {tx("standDetay.standiGor")}
                    </Button>
                    <Button color="info" outline={konumView !== "alan"} onClick={() => setKonumView("alan")}>
                      {tx("standDetay.alaniGor")}
                    </Button>
                  </ButtonGroup>
                </div>
                <RequiredFileRibbon label={tx("standDetay.konum")}>
                  {konumView === "stand" ? (
                    <div className="d-flex flex-column align-items-center py-2">
                      <KrokiShape size={180} point={elektrikExitPoint} />
                      {elektrikExitPoint && (
                        <div className="d-inline-flex align-items-center gap-1 small text-muted mt-2">
                          <span className="rounded-circle d-inline-block flex-shrink-0" style={{ width: 10, height: 10, background: "#dc3545" }} />
                          {tx("standDetay.elektrikCikisNoktasi")}
                        </div>
                      )}
                    </div>
                  ) : (
                    // WAS (until #439): <AlanKrokiPlaceholder salonName={stand.salonName} standCode={stand.standCode || stand.standName} />
                    <StandKonumKarti s={stand} mod="firma" />
                  )}
                </RequiredFileRibbon>
              </Col>
            </Row>
          </>
        )}

        {activeTab === "files" && (
          <div className="d-flex flex-column gap-3">
            <Alert color="info" className="mb-0">
              {tx("standDetay.herBelgeGrubunaDosyaYukleyebilirsiniz")}
            </Alert>
            {visibleDocGroups.map((g) => {
              if (g.standFileId === projeGorselleriStandFileId) {
                return (
                  <ProjeGorselleriSection
                    key={g.standFileId}
                    id={`proje-anchor-files-${g.standFileId}`}
                    files={(stand.uploadedFiles || []).filter((f) => f.standFileId === projeGorselleriStandFileId)}
                    angles={projeGorselleriAngles}
                    uploading={uploading || !projeYazabilir}
                    onUpload={(subStandFileId, file) => handleUpload(projeGorselleriStandFileId, file, subStandFileId)}
                    openRevision={openVisualByFile[projeGorselleriStandFileId]}
                    onShowRevision={setActiveRevision}
                    onPreview={setPreviewFile}
                    sablonlar={sablonlar}
                  />
                );
              }
              if (g.standFileId === 3) {
                return (
                  <TeknikTalepPlaniSection
                    key={g.standFileId}
                    id={`proje-anchor-files-${g.standFileId}`}
                    file={teknikTalepPlaniFile}
                    overallStatus={fileApprovalsMap[3] ?? 0}
                    uploading={uploading || !projeYazabilir}
                    onUpload={(file) => handleUpload(3, file, null, { plan: true })}
                    openRevision={openVisualByFile[3]}
                    onShowRevision={setActiveRevision}
                    onPreview={setPreviewFile}
                    onGoToTalepler={() => navigate(`/Firma/Talepler/${standId}?tab=teknikTalepler`)}
                  />
                );
              }
              return (
                <FirmaDocGroupRow
                  key={g.standFileId}
                  id={`proje-anchor-files-${g.standFileId}`}
                  label={g.label}
                  standFileId={g.standFileId}
                  overallStatus={fileApprovalsMap[g.standFileId] ?? 0}
                  files={(stand.uploadedFiles || []).filter((f) => f.standFileId === g.standFileId)}
                  uploading={uploading || !projeYazabilir}
                  onUpload={handleUpload}
                  openRevision={openVisualByFile[g.standFileId]}
                  onShowRevision={setActiveRevision}
                  onPreview={setPreviewFile}
                />
              );
            })}
          </div>
        )}

        {activeTab === "commitments" && (
          <RequiredFileRibbon label={tx("standDetay.insaIzniVeTaahhutnameler")}>
            <div className="w-100">
              <div className="d-flex justify-content-end mb-2">
                <Badge
                  color={stand.hasDebt ? "danger" : "secondary"}
                  className="d-inline-flex align-items-center gap-1 fw-normal"
                  title={stand.hasDebt ? tx("standDetay.borcNedeniyleInsaatIzniVerilemez") : undefined}
                >
                  <Coins size={11} />{" "}{tx("standDetay.borcDurumu")}{" "}{stand.hasDebt ? tx("standDetay.var") : tx("standDetay.yok")}
                </Badge>
              </div>
              <div className="d-flex justify-content-center mb-4">
                <div
                  className="d-flex flex-column align-items-center justify-content-center text-white fw-bold text-center rounded-3"
                  style={{ width: 96, height: 96, background: "#178f8f", fontSize: "0.8rem", lineHeight: 1.3 }}
                >
                  <div>{tx("standDetay.insaatIzni")}</div>
                  <div>{izinVar ? tx("standDetay.alindi") : tx("standDetay.alinmadi")}</div>
                </div>
              </div>
              {(stand.commitments || []).length === 0 ? (
                <Alert color="secondary" className="mb-0">{tx("standDetay.taahhutnameBulunamadi")}</Alert>
              ) : (
                <>
                  <Row>
                    {stand.commitments.map((c) => {
                      // Mock kayıtlar eski {status,fileId} şeklini taşıyor (bkz.
                      // standOverviewService.js'teki _mockStands) — canlı köprüde zaten
                      // stage/files dolu geliyor (mergeLiveProjectIntoStand), mock modda
                      // burada geriye dönük normalize edilir. Mock mod salt-okunur kalır
                      // (onUpload verilmez) — mock kayıtlar uploadedFiles'tan değil elle
                      // yazılmış status'tan geldiği için bir yükleme onu güncellemez.
                      const stage = c.stage ?? (c.status === 1 ? "done" : (c.fileId != null ? "draft" : "empty"));
                      const files = c.files ?? (c.fileId
                        ? [(stand.uploadedFiles || []).find((f) => f.id === c.fileId) ?? { id: c.fileId, originalFileName: "belge.pdf", approvalStatus: c.status ?? 0, uploadedAt: stand.updatedAt }]
                        : []);
                      return (
                        <CommitmentTile
                          key={c.key}
                          id={`proje-anchor-commitments-${c.key}`}
                          label={c.label}
                          stage={stage}
                          files={files}
                          uploading={uploading || !projeYazabilir}
                          onUpload={isLive ? (file) => handleUpload(5, file, c.subId ?? COMMITMENT_KEY_TO_SUBID[c.key]) : undefined}
                          onPreview={setPreviewFile}
                          isLive={isLive}
                          level={c.level}
                          elektrikciName={c.elektrikciName}
                        />
                      );
                    })}
                  </Row>
                  {isLive && stand.commitments.every((c) => c.stage === "done") && (
                    <Alert color="success" className="d-flex align-items-center gap-2 mb-0 mt-2">
                      <Check size={16} />{" "}{tx("standDetay.n3TaahhutnameDeTamamlandiInsaat")}
                    </Alert>
                  )}
                </>
              )}
            </div>
          </RequiredFileRibbon>
        )}

        {/* ─── MODAL: Revizyon Konuşması ───
            Belge revizyonunda yanıt YÜKLEMEDİR (ilgili belge satırından) — burada
            değer önerme kutusu bilerek yok, backend de reddederdi. Beyan alanı
            revizyonunda ise değer buradan önerilir ve KABUL EDİLENE KADAR projeye
            yazılmaz. */}
        <Modal isOpen={!!activeRevision} toggle={closeRevisionModal} size="lg">
          <ModalHeader toggle={closeRevisionModal}>
            {tx("standDetay.revizyon")}{" "}{activeRevision?.standFileId != null
              ? revisionFileLabel(activeRevision.standFileId)
              : (activeFieldMeta?.label ?? tx("standDetay.projeninGeneli"))}
          </ModalHeader>
          <ModalBody>
            <KuralIhlalListesi
              violations={revisionViolations}
              title={tx("standDetay.onerilenDegerBuFuarinKurallarina")}
            />
            <RevisionThread revision={activeRevision} viewerRole="company" fieldLabel={activeFieldMeta?.label} />
          </ModalBody>
          {activeRevision && isRevisionUnfinished(activeRevision) && (
            <ModalFooter className="d-block">
              {activeRevision.targetKind === "DOCUMENT" && (
                <Alert color="info" className="py-2 small">
                  {tx("standDetay.buRevizyonunYanitiBirMesaj")}{" "}<strong>{tx("standDetay.dosyaninYenidenYuklenmesidir")}</strong>{" "}{tx("standDetay.ilgiliBelgeSatirindakiYuklemeButonunu")}
                </Alert>
              )}
              {activeRevision.targetKind === "SPEC_FIELD" && (
                <div className="border rounded p-3 mb-3">
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <Inbox size={15} className="text-warning" />
                    <span className="fw-semibold">
                      {activeRevision.proposed ? tx("standDetay.yeniBirDegerOner") : tx("standDetay.degerOner")}
                    </span>
                  </div>
                  <p className="text-muted small">
                    {tx("standDetay.onerdiginizDegerIncelemeEkibiOnaylayana")}
                    {activeRevision.proposed && tx("standDetay.yeniOnerinizMasadakiOnerininYerine")}
                  </p>
                  <FormGroup>
                    <Label>{activeFieldMeta?.label ?? activeRevision.fieldKey}</Label>
                    {activeFieldMeta?.valueType === "BOOLEAN" ? (
                      <Input type="select" value={proposalValue} onChange={(e) => setProposalValue(e.target.value)}>
                        <option value="">{tx("standDetay.secin")}</option>
                        <option value="true">{tx("common:evet")}</option>
                        <option value="false">{tx("common:hayir")}</option>
                      </Input>
                    ) : (
                      <Input
                        type="number"
                        step={activeFieldMeta?.valueType === "INTEGER" ? "1" : "0.01"}
                        value={proposalValue}
                        onChange={(e) => setProposalValue(e.target.value)}
                      />
                    )}
                  </FormGroup>
                  <FormGroup>
                    <Label>{tx("standDetay.aciklamaOpsiyonel")}</Label>
                    <Input
                      type="textarea" rows={2}
                      placeholder={tx("standDetay.nedenBuDegeriOnerdiginiziYazin")}
                      value={proposalNote}
                      onChange={(e) => setProposalNote(e.target.value)}
                    />
                  </FormGroup>
                  <div className="d-flex justify-content-end">
                    <Button color="primary" size="sm" disabled={revisionBusy || !String(proposalValue).trim()} onClick={handleProposeValue}>
                      {revisionBusy ? <Spinner size="sm" className="me-1" /> : <Send size={13} className="me-1" />}
                      {tx("standDetay.oneriyiGonder")}
                    </Button>
                  </div>
                </div>
              )}
              <Input
                type="textarea" rows={2}
                placeholder={tx("standDetay.konusmayaMesajYazin")}
                value={revisionReply}
                onChange={(e) => setRevisionReply(e.target.value)}
                disabled={revisionBusy}
              />
              <div className="d-flex justify-content-end mt-2">
                <Button color="secondary" outline size="sm" disabled={revisionBusy || !revisionReply.trim()} onClick={handleRevisionReply}>
                  {revisionBusy ? <Spinner size="sm" className="me-1" /> : <Send size={13} className="me-1" />}
                  {tx("standDetay.mesajGonder")}
                </Button>
              </div>
            </ModalFooter>
          )}
        </Modal>

        <DocumentPreviewModal
          isOpen={!!previewFile}
          toggle={() => setPreviewFile(null)}
          fileName={previewFile?.originalFileName}
          fileUrl={isLive ? getProjectFileUrl(previewFile?.storedFileName) : undefined}
        />
      </Container>
    </div>
  );
}
